import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectSpaces } from '../_redux-photos';

const createSpacesSelector = (photoId: string) =>
  createSelector(
    [(state: PhotoPrintsPdpState) => selectSpaces(state, photoId)],
    (spaces) => spaces
  );

export const useMemoizedSpaces = (photoId: string) => {

  const selector = useMemo(() => createSpacesSelector(photoId), [photoId]);
  
  return useSelector(selector, shallowEqual);
};